module.exports = "/images/Netherlands.png?1ff4951a0629a9309ffe274307103169";